const PRODUCTS = {
  PICKLEBALL_PADDLE_BY_RECESS: 48166,
  PICKLEBALL_PADDLE_SET_BY_RECESS: 48167
}

export function isPreOrder(productId) {
  return productId == PRODUCTS.PICKLEBALL_PADDLE_BY_RECESS ||
    productId == PRODUCTS.PICKLEBALL_PADDLE_SET_BY_RECESS
}

export function getColors(product) {
  return product.fabric?.colors?.map(({name}) => name)
    .join(', ');
}
